import {computed, defineComponent, type PropType} from 'vue';
import {useUserStore} from "@/app/stores/user-store.ts";
import {getNameByIsoCode} from "@/app/shared/helpers/country.ts";
import {AthumiService} from "@/api/enterprise-gateway-api.proxy.ts";
import { storeToRefs } from 'pinia';
import MailIcon from '@primeicons/vue/envelope';
import LocationIcon from '@primeicons/vue/map-marker';

export default defineComponent({
    props: {
        service: {
            type: String as PropType<AthumiService>,
            required: false,
            default: AthumiService.ELys
        }
    },
    name: 'AegAddressDetails',
    components: { MailIcon, LocationIcon },
    setup(props) {
        const userStore = useUserStore();

        const {hasAddress, hasEmail, user} = storeToRefs(userStore);
        const actorInfo = computed(() => {
            return user.value.actors ? user.value.actors[props.service!] : user.value.actorInfo;
        });

        
        const billingAddress = computed(() => {
            if (!hasAddress.value) {
                return 'Niet gekend';
            }
            const streetParts = [actorInfo.value?.street, actorInfo.value?.streetNumber, `${actorInfo.value?.bus ? `bus ${actorInfo.value.bus}` : ''}`].join(' ').trim();
            const cityParts = `- ${[actorInfo.value?.postCode, actorInfo.value?.city].join(' ').trim()}${actorInfo.value?.city && actorInfo.value?.countryCode ? ` - ${getNameByIsoCode(actorInfo.value?.countryCode)}` : ''}`;
            return `${streetParts} ${cityParts}`.trim();
        });

        const emailAddress = computed((): string => {
            return actorInfo.value?.email ?? 'Niet gekend';
        })

        return {
            actorInfo,
            emailAddress,
            hasEmail,
            billingAddress,
            hasAddress,
        }
    }
})
